var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', [_c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('PageTitle', {
    attrs: {
      "title": "Назначение конкурса"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    staticClass: "white--text px-4 mr-2",
    attrs: {
      "small": "",
      "outlined": "",
      "rounded": "",
      "disabled": !_vm.selected.length,
      "loading": _vm.appointLoading,
      "color": "primary"
    },
    on: {
      "click": _vm.appoint
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" Назначить конкурс ")], 1), _c('v-btn', {
    staticClass: "white--text px-4 mr-2",
    attrs: {
      "small": "",
      "outlined": "",
      "rounded": "",
      "color": "primary",
      "disabled": !_vm.selected.length,
      "loading": _vm.cancelLoading
    },
    on: {
      "click": _vm.cancel
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-minus")]), _vm._v(" Отменить конкурс ")], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('PageTable', {
    attrs: {
      "show-select": "",
      "table-loading": _vm.tableLoading,
      "table-headers": _vm.tableHeaders,
      "filter": "",
      "table-items": _vm.vacancyParent.list,
      "table-height": "284"
    },
    scopedSlots: _vm._u([{
      key: "button",
      fn: function fn() {
        return [_c('v-badge', {
          attrs: {
            "overlap": "",
            "dot": "",
            "value": !!_vm.checkFilterProperties
          }
        }, [_vm.checkRoles ? _c('v-btn', {
          staticClass: "white--text ml-4 filter-btn",
          attrs: {
            "small": "",
            "rounded": "",
            "outlined": "",
            "color": "primary"
          },
          on: {
            "click": function click($event) {
              _vm.showFilter = !_vm.showFilter;
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "left": "",
            "small": ""
          }
        }, [_vm._v("mdi-filter-outline")]), _c('span', [_vm._v(_vm._s(_vm.showFilter ? 'Закрыть' : 'Фильтр'))])], 1) : _vm._e()], 1)];
      },
      proxy: true
    }, {
      key: "item.actions",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('v-icon', {
          staticClass: "mr-1 edit-btn",
          attrs: {
            "color": "lightGrey",
            "size": "22",
            "title": "Просмотр"
          },
          on: {
            "click": function click($event) {
              return _vm.show(item);
            }
          }
        }, [_vm._v(" mdi-eye ")])];
      }
    }]),
    model: {
      value: _vm.selected,
      callback: function callback($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  }), _c('transition', {
    attrs: {
      "name": "curator-filter"
    }
  }, [_c('ContestFilterDialog', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showFilter,
      expression: "showFilter"
    }],
    attrs: {
      "vacancy-filter": _vm.vacancyFilter,
      "width-filter": "300",
      "top": "255",
      "right": "29"
    },
    on: {
      "applyFilter": _vm.applyFilter,
      "closeFilter": function closeFilter($event) {
        _vm.showFilter = false;
      }
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }